import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';
import { BUSINESS_TYPE_FOR_PROFIT_OR_NON_PROFIT } from '../../../../../../../constants';

const { businessTypeForProfitOrNonProfit } = loanFormModel.formField;

class BusinessTypeIsForProfit implements Rule {
  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    const businessType = application[
      businessTypeForProfitOrNonProfit.name
    ] as BUSINESS_TYPE_FOR_PROFIT_OR_NON_PROFIT | null;
    return (
      businessType !== null &&
      businessType !== undefined &&
      businessType === BUSINESS_TYPE_FOR_PROFIT_OR_NON_PROFIT.FOR_PROFIT
    );
  }
}

export default new BusinessTypeIsForProfit();
